import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import styled, { createGlobalStyle } from 'styled-components';
import { setLoginModalOpen } from '../../Actions/Login.action';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import LoginMode from '../../Types/LoginMode';
import LoginContainer from './LoginContainer';
import SideMenu from '../SideMenu/SideMenu';
import { breakpoint } from '../../styling/mixins/breakpoints';
import { getColor } from '../../styling/mixins/colors';

const StyledLoginModal = styled(SideMenu)`
  z-index: 60;
  overflow-y: auto;
  
  ${breakpoint('small')} {
    border - left: 1px solid ${getColor('grey', 300)};
  }
  
  .content {
    padding: 4rem 2.4rem;
  }
`;

const GlobalLoginModalStyling = createGlobalStyle`
  body #overlay - container.overlay--login - modal {
  z - index: 55;
}
`;

const LoginModal = () => {
  const { modalOpen, loginMode, isLoading } = useTypedSelector(
    (state) => state.login
  );
  const dispatch = useDispatch();
  const disableClosing = useMemo(
    () =>
      loginMode == LoginMode.ChangePassword ||
      loginMode == LoginMode.SelectOrganization,
    [loginMode]
  );


  return (
    <StyledLoginModal
      id="login-modal"
      open={modalOpen}
      onClosed={() => dispatch(setLoginModalOpen(false))}
      disableClosing={disableClosing || isLoading}
    >
      <div className="content">
        <LoginContainer />
      </div>
      <GlobalLoginModalStyling />
    </StyledLoginModal>
  );
};

export default LoginModal;
